import Health from '../image/heath.png'
import ImageSearch from '../image/imagesearch.png'
import Todo from '../image/todoapp.png'
import Spotify from '../image/spotify.png'
import MySociety from '../image/mysociety.png'
import Blog from '../image/blog.png'
import Weather from '../image/weather.png'
import Microsoft from '../image/microsoft.png'
import Youtube from '../image/youtube.png'
import Rajpurohit from '../image/rajpurohitm.png'
// import Netflix from '../image/netflix.png'

export default [
    // {
        //     title:'Netflix Clone',
    //     imgUrl:Netflix,
    //     tech: ['React js', 'Tailwind CSS', 'Firebase'],
    //     workUrl:'https://kuldeepnetflixapp.netlify.app/'
    // },
    {
        title:'Rajpurohitm',
        imgUrl:Rajpurohit,
        tech: ['Next js', 'React js', 'Tailwind CSS', 'Directus CMS'],
        workUrl:'https://rajpurohitm.com/'
    },
    {
        title:'My Society',
        imgUrl:MySociety,
        tech: ['React js', 'Tailwind CSS', 'Node js', 'Express js', 'Mongodb'],
        workUrl:'https://mysociety-frontend.onrender.com/'
    },
    
    {
        title:'Spotify Clone',
        imgUrl:Spotify,
        tech: ['React js', 'Tailwind CSS', 'Node js', 'Express js', 'Mongodb'],
        workUrl:'https://spotify-clone-vnki.onrender.com/'
    },
    
    {
        title:'Youtube Clone',
        imgUrl:Youtube,
        tech: ['React js', 'Rapid Api', 'Tailwind CSS'],
        workUrl:'https://youtube-br80.onrender.com/'
    },

    {
        title:'Search Images',
        imgUrl:ImageSearch,
        tech: ['React js', 'CSS', 'API'],
        workUrl:'https://imagekuldeep.netlify.app/'
    },

    {
        title:'Weather App',
        imgUrl:Weather,
        tech: ['React js', 'CSS', 'OpenWeather API'],
        workUrl:'https://weather-app-6978.onrender.com/'
    },



    {
        title:'Todo App',
        imgUrl:Todo,
        tech: ['React js', 'Tailwind CSS'],
        workUrl:'https://todolistkuldeep.netlify.app/'
    },

    {
        title:'Health',
        imgUrl:Health,
        tech: ['HTML', 'Tailwind CSS', 'JavaScript'],
        workUrl:'https://healthkuldeepsite.netlify.app/'
    },

    {
        title:'Blog',
        imgUrl:Blog,
        tech: ['HTML', 'Tailwind CSS'],
        workUrl:'https://sabrinablog.netlify.app/'
    },

    {
        title:'Microsoft UI',
        imgUrl:Microsoft,
        tech: ['HTML', 'Tailwind CSS'],
        workUrl:'https://mircosoft-clone.netlify.app/'
    },
]
